import { defineLocaleTargets } from '@accesso/cc-std-lib';

export const ProductErrorsSection = 'producterrors';

export const ProductErrors = defineLocaleTargets(ProductErrorsSection, {
	selectQuantity: '',
	selectDate: '',
	selectTime: '',
	maxQuantity: '',
	minQuantity: '',
	addToCart: '',
});
